import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useLanguage } from "contexts/language.context";
import { INTERNAL } from "const";
import { getPillarOptions } from "./consolidatedPillarSelection";

export default function AuditsConsolidatedPillarSelection({
  data,
  setData,
  disabled,
}) {
  const { label } = useLanguage();
  const pillars = getPillarOptions(data.branches);
  const selected = data.selectedPillarIds || [];
  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        {label("consolidated-pillar-instructions") ||
          "Uncheck pillars to exclude them. Pillars missing from some selected audits can still be included."}
      </Alert>
      {!pillars.length && (
        <Typography>
          {label("consolidated-no-pillars") ||
            "No pillars are available in the selected reports."}
        </Typography>
      )}
      {pillars.map((pillar) => {
        const checked = selected.includes(pillar.pillarId);
        return (
          <Box
            key={pillar.pillarId}
            sx={{ py: 1, borderBottom: 1, borderColor: "divider" }}
          >
            <FormControlLabel
              label={[pillar.referenceCode, pillar.description]
                .filter(Boolean)
                .join(". ")}
              control={
                <Checkbox
                  checked={checked}
                  disabled={disabled}
                  onChange={(event) => {
                    const include = event.target.checked;
                    setData((current) => ({
                      ...current,
                      selectedPillarIds: include
                        ? [
                            ...new Set([
                              ...current.selectedPillarIds,
                              pillar.pillarId,
                            ]),
                          ]
                        : current.selectedPillarIds.filter(
                            (id) => id !== pillar.pillarId,
                          ),
                    }));
                  }}
                />
              }
            />
            {checked && pillar.missingAudits.length > 0 && (
              <Alert severity="warning" sx={{ mb: 1 }}>
                {label("consolidated-pillar-missing") ||
                  "This pillar is missing from these selected audits:"}
                <ul style={{ paddingInlineStart: 24, margin: 0 }}>
                  {pillar.missingAudits.map((audit) => (
                    <li key={audit.id}>
                      {[
                        audit.branchName,
                        audit.description,
                        audit.type === INTERNAL
                          ? label("internal") || "Internal"
                          : label("external") || "External",
                        audit.date
                          ? new Date(audit.date).toLocaleDateString()
                          : null,
                        `#${audit.id}`,
                      ]
                        .filter(Boolean)
                        .join(" — ")}
                    </li>
                  ))}
                </ul>
              </Alert>
            )}
          </Box>
        );
      })}
      {pillars.length > 0 && !selected.length && (
        <Alert severity="info" sx={{ mt: 2 }}>
          {label("consolidated-empty-pillars") ||
            "All pillars are excluded. The report contains no pillar results."}
        </Alert>
      )}
    </Box>
  );
}
